import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser,
  CognitoRefreshToken
} from 'amazon-cognito-identity-js';

import config from '../config';
import { resolve } from './parser';

export function forgotPassword(email, success, error) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  });

  const cognitoUser = new CognitoUser({
    Username: email,
    Pool: userPool
  });

  cognitoUser.forgotPassword({
    onSuccess: function(result) {
      success(result);
    },
    onFailure: error
  });
}

export function confirmPassword(email, verificationCode, newPassword) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  });

  const cognitoUser = new CognitoUser({
    Username: email,
    Pool: userPool
  });

  return new Promise((resolve, reject) => {
    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onFailure(err) {
        reject(err);
      },
      onSuccess() {
        resolve();
      }
    });
  });
}

/**
 * Gets the tokens from the localStorage
 */
export function getAccessToken() {
  const userPool = getCognitoUserPool();
  const cognitoUser = userPool.getCurrentUser();

  if (cognitoUser) {
    return new Promise((resolve, reject) => {
      cognitoUser.getSession(function(err, session) {
        if (err) {
          reject(err);
        } else {
          resolve(session.accessToken.jwtToken);
        }
      });
    });
  }
}

/**
 * A session is valid if the tokens are valid.
 */
export function isSessionValid() {
  const userPool = getCognitoUserPool();
  const cognitoUser = userPool.getCurrentUser();

  if (cognitoUser) {
    return new Promise(resolve => {
      cognitoUser.getSession(function(err, session) {
        if (err) {
          resolve(false);
        } else {
          resolve(session.isValid());
        }
      });
    }).catch(err => {
      resolve(false);
    });
  } else {
    return false;
  }
}

/**
 * Refresh session.
 * @returns {refreshed:boolean, tokens:{}}
 */
export function refreshSession() {
  const userPool = getCognitoUserPool();
  const cognitoUser = userPool.getCurrentUser();

  let refreshToken = '';
  if (cognitoUser) {
    cognitoUser.getSession(function(err, data) {
      if (err) {
        console.error('Couldn t get session');
      } else {
        refreshToken = data.refreshToken.token;
      }
    });
    return new Promise(resolve => {
      cognitoUser.refreshSession(
        new CognitoRefreshToken({ RefreshToken: refreshToken }),
        function(err, data) {
          if (err) {
            resolve({ refreshed: false, tokens: null });
          } else {
            const tokens = {
              accessToken: data.accessToken.jwtToken,
              idToken: data.idToken.jwtToken,
              refreshToken: data.refreshToken.token
            };
            resolve({ refreshed: true, tokens: tokens });
          }
        }
      );
    });
  } else {
    return new Promise(resolve => {
      resolve({ refreshed: false, tokens: [] });
    });
  }
}

export function getCognitoUserPool() {
  return new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  });
}



// WEBPACK FOOTER //
// ./lib/cognitoHelper.js